<template>
  <div>
    <section class="xlrclh">
      <img class="top-img" src="../../assets/imgs/qingbaijiang/1/title-bg.png" alt="" />
      <div class="technological-process">
        <div class="rhtj mar-t2">
          <img class="top" src="../../assets/imgs/125/desc-title.png" alt="" />
          <div class="content">
            支持我区企业在知名高校设立专项奖学金，按奖学金总额的50%给予补贴。
          </div>
        </div>
        <div class="sxcl">
          <img class="top" src="../../assets/imgs/25/title-1.png" alt="" />
          <div class="content" style="padding-bottom: 0.3rem;">
            <span class="hollow-cricle"></span
            ><span class="title" style="font-size: 0.33rem;">申报“企业专项奖学金”奖励的企业需满足以下条件：</span>
            <div class="des">（一）企业注册地和主要税收缴纳关系均在我区。</div>
            <div class="des">（二）企业在当年度最新QS世界大学综合排名前300的海内外知名高校以及国内“双一流”高校设立专项奖学金。</div>
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="../../assets/imgs/25/title-2.png" alt="" />
          <div class="content">
            <div class="des" style="margin-top: 0; padding: 0">
              <div>
                对我区在当年度最新QS世界大学综合排名前300的海内外知名高校以及国内“双一流”高校设立专项奖学金的企业，按照奖学金总额的50%给予补贴。
              </div>
            </div>
          </div>
        </div>
        <div class="gmlc">
          <img class="top" src="../../assets/imgs/25/title-3.png" alt="" />
          <div class="content">
            <div class="des mar-t3">
              <div class="line-item">
                <div class="line"></div>
                <div class="line-top">
                  <div class="line-num">1</div>
                  <div class="line-title">申报</div>
                </div>
                <div class="line-content">
                  企业向人才窗口提交申请表和相关申报材料。
                </div>
              </div>
              <div class="line-item">
                <div class="line"></div>
                <div class="line-top">
                  <div class="line-num">2</div>
                  <div class="line-title">受理</div>
                </div>
                <div class="line-content">
                  人才窗口对申报材料进行形式审查，合格的，予以受理；不合格的，现场作出说明并退回申请材料。
                </div>
              </div>
              <div class="line-item">
                <div class="line"></div>
                <div class="line-top">
                  <div class="line-num">3</div>
                  <div class="line-title">审核</div>
                </div>
                <div class="line-content">
                  人才窗口将受理合格的申报材料交区委组织部（区人才办），区委组织部（区人才办）会同区教育局、区人社局对企业设立奖学金的高校是否符合要求进行审核，区委组织部（区人才办）会同企业所在园区管委会或镇街等载体单位、区教育局、区财政局对企业设立奖学金真实性、设立金额进行审核，由区委组织部（区人才办）汇总有关情况形成审核意见。审核通过后，按程序报区人才工作领导小组会议审定。
                </div>
              </div>
              <div class="line-item">
                <div class="line-top">
                  <div class="line-num">4</div>
                  <div class="line-title">资金拨付</div>
                </div>
                <div class="line-content">
                  审定通过后，区委组织部（区人才办）按程序将相关资金拨载体单位，由载体单位向申请对象一次性发放。
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="contact" style="margin-top: 0.8rem">
          <img class="top" src="../../assets/imgs/25/title-4.png" alt="" />
          <div class="content">
            <div class="number">
              <span class="label">政策咨询电话：</span>
              <div>
                <a href="tel:028—61760181">028—61760181</a>
              </div>
            </div>
            <div class="unit">
              <span class="label">责任单位：</span>
              区委组织部（区委人才办）
            </div>
            <div class="site">
              <span class="label">地址：</span>
              青江中路183号
            </div>
          </div>
        </div>
        <!-- <div class="codes">
          <img class="code" src="../assets/imgs/54/code.png" />
          <img class="text" src="../assets/imgs/54/text.png" />
        </div> -->
      </div>
    </section>
    <!-- <call phone="028-83221725"></call> -->
  </div>
</template>

<script>
import call from "../../components/call.vue";
export default {
  data() {
    return {};
  },

  components: {
    call,
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
  background-color: $base-back;

  .top-img {
    width: 7.26rem;
    height: 5.6rem;
  }

  .technological-process {
    transform: translateY(-2.5rem);

    .rhtj {
      position: relative;

      .top {
        width: 6.86rem;
        height: 2.12rem;
      }

      .content {
        width: 6.85rem;
        background: #fff;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        font-size: 0.26rem;
        // font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #4e4e4e;
        line-height: 0.44rem;

        text-align: left;
      }
    }
    .zccl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #fff;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        line-height: 0.44rem;

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.35rem 0.23rem 0.3rem;
          position: relative;
          text-align: left;
          margin-top: 0.8rem;
          .title {
            position: absolute;
            top: -0.5rem;
            left: 50%;
            transform: translateX(-50%);
            min-width: 3.74rem;
            height: 0.67rem;
            line-height: 0.67rem;
            display: flex;
            justify-content: center;
            align-content: center;
            font-size: 0.32rem;
            font-weight: bold;
            color: #ffffff;
            border-radius: 1rem;
            background-color: #739bfe;
          }
        }
      }
    }

    .sxcl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.45rem auto 0;
        padding: 0 0.33rem 0.64rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        line-height: 0.4rem;
        .title {
          font-size: 0.35rem;
          color: #333;
          font-weight: 600;
        }

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem;
          padding: 0.22rem;
          font-weight: 500;
          margin-top: 0.25rem;
          position: relative;
        }
      }
    }

    .sbcl {
      position: relative;
      margin-top: 0.22rem;
      line-height: 0.44rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #fff;
        margin: -0.45rem auto 0;
        padding: 0.33rem 0.64rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
      }
    }

    .gmlc {
      position: relative;
      margin-top: 0.22rem;
      // line-height: 0.44rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.59rem auto;
        padding: 0 0.33rem 0.35rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;

        .title {
          font-size: 0.36rem;
          font-weight: bold;
          color: #333333;
          text-align: left;
          line-height: 0.5rem;
        }

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.3rem 0.23rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;

          .line-item {
            font-size: 0.26rem;
            position: relative;
            z-index: 3;

            .line {
              position: absolute;
              width: 0.02rem;
              height: 100%;
              border-left: 0.02rem dashed #739bfe;
              left: 0.2rem;
              z-index: 0;
              //   background-color: #739bfe;
            }

            .line-title {
              font-size: 0.3rem;
              font-weight: bold;
              color: #3d5aa3;
            }

            .line-top {
              display: flex;
              width: 3.31rem;
              height: 0.49rem;
              background-image: url(../../assets/imgs/25/label.png);
              background-size: 100% 100%;
              z-index: 99;
              display: flex;
              align-items: center;
              box-sizing: border-box;
              padding-left: 0.08rem;

              .line-num {
                width: 0.39rem;
                height: 0.39rem;
                background: #fff;
                color: #3A73FF;
                display: inline-flex;
                border-radius: 50%;
                justify-content: center;
                align-items: center;
                margin-right: 0.14rem;
                position: relative;
                z-index: 3;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.28rem;
                font-weight: bold;
              }
            }

            .line-content {
              //   border-left: 0.02rem dashed #739bfe;
              padding-bottom: 0.32rem;
              margin-left: 0.2rem;
              padding-left: 0.32rem;
              padding-top: 0.15rem;
              word-break: break-all;
              line-height: 0.44rem;
            }
          }
        }
      }
    }

    .codes {
      margin: 0 auto;
      margin-top: 0.25rem;
      width: 6.85rem;
      background: #fff;
      padding: 0.3rem;
      box-sizing: border-box;
      border-radius: 0.26rem;
      padding-top: 0.28rem;
      font-size: 0.26rem;
      font-weight: 500;
      color: #4e4e4e;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .code {
        width: 1.94rem;
        height: 1.94rem;
      }

      .text {
        height: 1.75rem;
      }
    }
  }
}
</style>
